$(document).ready(function() {

  // Menu dropdown hack voor iPhone etc
  $('.navbar-toggle').click(function(){
  	console.log('CLICK');
  });


	// Share
	$('.share').click(function(){
		$(this).toggleClass('open');
	});
	$('.share').mouseenter(function(){
		$(this).addClass('open');
	});
	$('.share-links').mouseleave(function(){
		$('.share').removeClass('open');
	});

	// Zoeken
	$('.search-results').each(function(){
		var auteur 	= get_search_variable('auteur');
		var rubriek = get_search_variable('rubriek');
		var query 	= get_search_variable('query');
		var order 	= get_search_variable('order');

		$('form',this).submit(function(e){
			e.preventDefault();
			return false;
		});

		$('select[name=auteur]',this).change(function(){
			auteur = this.value;
			searchUri();
		});
		$('select[name=rubriek]',this).change(function(){
			rubriek = this.value;
			searchUri();
		});
		$('input[name=query]',this).keyup(function(e){
			e.preventDefault();
			if (e.keyCode==13) {
				query = this.value;
				searchUri();
			}
			return false;
		});

		$('.order .fa',this).click(function(){
			order=$(this).attr('data-order');
			searchUri();
		});


		function searchUri() {
			var uri = location.pathname + '?auteur='+auteur + '&rubriek='+rubriek + '&query='+query +'&order='+order;
			location.href = uri;
		}

		function get_search_variable(variable) {
			var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
      }
      return "";
		}

	});

});

$(window).load(function() {
  var max_width = $('.article').width();
  $('.article img').each(function(){
    var width = $(this).width();
    if ( width >= (max_width/2) ) {
      $(this).css({'width':'100%'});
    }
  });
});
